import React, { useState } from 'react';
import {
    Flex,
    Button,
    BottomSheet,
    BottomSheetContent,
    BottomSheetHeader,
    BottomSheetBody,
    BottomSheetFooter,
    Box,
} from '@shared/ui';
import i18n from '@shared/i18n';
import { ProductCard } from 'app/components/ProductCard';
import { SpecSelection } from '../SpecSelection';

interface MobileBottomSheetProps {
    productCard: ProductCard;
    visible: boolean;
    selectedSpec: ProductSpecDetail | null;
    quantity: number;
    onClose: () => void;
    onSelectSpec: (spec: ProductSpecDetail) => void;
    onAddToCart: (item: ProductCard) => Promise<void | null>;
    onUpdateQuantity: (quantity: number) => void;
}

export const MobileBottomSheet: React.FC<MobileBottomSheetProps> = ({
    productCard,
    visible,
    selectedSpec,
    quantity,
    onClose,
    onSelectSpec,
    onAddToCart,
    onUpdateQuantity,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleAddToCart = async (item: ProductCard) => {
        setIsLoading(true);

        try {
            await onAddToCart(item);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const discountedPrice =
        productCard.discounted_price?.value !== productCard.price.value
            ? productCard.discounted_price?.value
            : null;

    return (
        <BottomSheet useDragBar={false} onClose={onClose}>
            <BottomSheetContent isOpen={visible}>
                <BottomSheetHeader> {i18n.gettext('你可能會喜歡')}</BottomSheetHeader>
                <BottomSheetBody>
                    <Box
                        maxH={{
                            sm: 'unset',
                            md: '600px',
                        }}
                        overflowY="scroll"
                    >
                        <Flex flexDirection="column" mt="15px" gap="m">
                            <ProductCard.CartGiveaway
                                productId={productCard.id}
                                name={productCard.name}
                                price={productCard.price}
                                quantity={quantity}
                                image={productCard.image as ProductDisplayMedia}
                                discountedPrice={discountedPrice}
                                onChange={(_, value) => onUpdateQuantity(value)}
                                addOnLimit={9999}
                            />
                            <Box my="xs">
                                <SpecSelection
                                    addonIndex={0}
                                    specDetails={productCard.spec_details}
                                    specMetas={productCard.spec_metas}
                                    onSelect={(spec) =>
                                        onSelectSpec(spec as ProductSpecDetail)
                                    }
                                    selectedSpecs={[]}
                                />
                            </Box>
                        </Flex>
                    </Box>
                </BottomSheetBody>
                <BottomSheetFooter>
                    <Flex h="40px" w="100%">
                        <Button
                            isDisabled={!selectedSpec}
                            onClick={() => handleAddToCart(productCard)}
                            isLoading={isLoading}
                        >
                            {i18n.gettext('確定加購')}
                        </Button>
                    </Flex>
                </BottomSheetFooter>
            </BottomSheetContent>
        </BottomSheet>
    );
};
